import { useAuthGetWecomUrl } from '@/api'

const QyWechatAuth = () => {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const spaceId = searchParams.get('space_id')
  const isWeb = searchParams.get('is_web')
  const detailUrl = searchParams.get('detail_url')
  const isWebBool = isWeb === 'true'

  const { data: authUrl } = useAuthGetWecomUrl({
    space_id: Number(spaceId),
    is_web: isWebBool,
    detail_url: detailUrl ?? undefined,
  })

  useEffect(() => {
    if (authUrl) {
      window.location.href = authUrl
    }
  }, [authUrl])

  return <div></div>
}

export default QyWechatAuth
